/* global femcare */

femcare.quiz.nps = {
    init: function() {
        this.$popup = $('.survey-popup');

        if (this.$popup.length) {
            this.$question = $('.survey-popup__question');
            this.$answers = $('.survey-popup__answer');
            this.$completedMessage = $('.survey-popup__completed');
            this.$closeButton = $('.survey-popup__close');

            var completionCookieName = this.$popup.data('completionCookieName');
            if (this.readCookie(completionCookieName)) {
                return;
            }

            var timerCookieName = completionCookieName + '-t';
            this.initEventHandlers(completionCookieName, timerCookieName);
            this.initTimer(timerCookieName);
        }
    },

    initTimer: function(timerCookieName) {
        var startDelaySeconds = parseInt(this.$popup.data('startDelaySeconds'), 10);
        var timerCookie = this.readCookie(timerCookieName);
        var elapsedSeconds = (timerCookie && parseInt(timerCookie, 10)) || 0;
        var intevalNumber = 1000;

        var interval = setInterval(
            $.proxy(function() {
                elapsedSeconds += 1;

                if (elapsedSeconds >= startDelaySeconds) {
                    clearInterval(interval);
                    this.$popup.show();

                    return;
                }

                this.writeCookie(timerCookieName, elapsedSeconds, null);
            }, this),
            intevalNumber
        );
    },

    initEventHandlers: function(completionCookieName, timerCookieName) {
        var completionCookieExpiryDays = parseInt(
            this.$popup.data('completionCookieExpiryDays'),
            10
        );
        var expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + completionCookieExpiryDays);

        this.$answers.on(
            'click',
            null,
            null,
            $.proxy(function(e) {
                $.ajax({
                    type: 'POST',
                    url: this.$popup.data('postUrl'),
                    data: JSON.stringify({
                        quizId: this.$popup.data('surveyId'),
                        answers: [$(e.currentTarget).data('value')]
                    }),
                    contentType: 'application/json'
                });

                this.$closeButton.hide();
                this.$question.hide();
                this.$answers.hide();
                this.$completedMessage.show();

                this.writeCookie(completionCookieName, 'true', expiryDate);
                this.removeCookie(timerCookieName);

                setTimeout(
                    $.proxy(function() {
                        this.$popup.hide();
                    }, this),
                    2000
                );
            }, this)
        );

        this.$closeButton.click(
            $.proxy(function() {
                this.$popup.hide();
                this.writeCookie(completionCookieName, 'true', expiryDate);
                this.removeCookie(timerCookieName);
            }, this)
        );
    },

    readCookie: function(cookieName) {
        var match = document.cookie.match(
            new RegExp('(^|;\\s*)(' + cookieName + ')=([^;]*)')
        );
        var itemNumber = 3;

        return match ? decodeURIComponent(match[itemNumber]) : null;
    },

    writeCookie: function(cookieName, value, expires) {
        var cookie = [];
        cookie.push(cookieName + '=' + encodeURIComponent(value));
        if (expires) {
            cookie.push('expires=' + new Date(expires).toGMTString());
        }
        cookie.push('path=/');
        document.cookie = cookie.join('; ');
    },

    removeCookie: function remove(cookieName) {
        var dateReduce = 1000;
        this.writeCookie(cookieName, '', Date.now() - dateReduce);
    }
};
